import * as React from 'react';
import { clsx } from 'clsx';
import styles from './Step.css';

interface IStepProps {
  step: string;
  theme?: 'primary' | 'secondary';
}

export const Step: React.FC<IStepProps> = ({ step, theme = 'secondary' }) => {
  return <div className={clsx(styles['step'], theme && styles[theme])}>{step}</div>;
};
